import { BlockSectionBackground as Background } from "./BlockSectionBackground";
import { BlockSectionNestedBlock as NestedBlock } from "./BlockSectionBlock";
import { BlockSectionContainer as Container } from "./BlockSectionContainer";
import { BlockSectionContent as Content } from "./BlockSectionContent";
import { BlockSectionRoot } from "./BlockSectionRoot";

export const BlockSection = Object.assign(BlockSectionRoot, {
  Container,
  Background,
  Content,
  NestedBlock,
});
